import React, { Component } from "react";

export default class ThankYou extends Component {
  state = {};
  render() {
    return (
      <div className="thank-you-container">
        <h2 className="thank-you-header">Thank You!</h2>
        <p className="thank-you-paragraph">
          Thank you for visiting us. We hope you had a pleasant experience and
          would greatly appreciate if you would share your feedback with others
          who may be looking for a trusted business.
        </p>
        <p className="thank-you-paragraph">
          Please click on one of the review site icons below to share your
          experience.
        </p>
        <p className="thank-you-paragraph">
          We truly appreciate your business and your feedback!
        </p>
      </div>
    );
  }
}
